// src/api/ratings.ts
import axiosInstance from './axiosInstance';

export interface MessageRating {
  id?: number;
  user_id?: number;
  username?: string;
  database_id: number;
  database_name?: string;
  is_valid: boolean;
  messages: Array<{
    role: 'user' | 'assistant';
    content: string | {
      sql?: string;
      explanation?: string;
    };
  }>;
  created_at?: string;
}

export interface RatingsListResponse {
  ratings: MessageRating[];
  total: number;
}

export interface RatingsFilters {
  database_id?: number;
  is_valid?: boolean;
  username?: string;
  skip?: number;
  limit?: number;
}

/**
 * Создание оценки сообщения
 */
export async function createMessageRating(rating: MessageRating): Promise<MessageRating> {
  const response = await axiosInstance.post('/message-ratings', rating);
  return response.data;
}

/**
 * Получение списка оценок с фильтрами
 */
export async function getMessageRatings(filters?: RatingsFilters): Promise<RatingsListResponse> {
  const response = await axiosInstance.get('/message-ratings', { params: filters });
  return response.data;
}

/**
 * Получение конкретной оценки по ID
 */
export async function getMessageRating(ratingId: number): Promise<MessageRating> {
  const response = await axiosInstance.get(`/message-ratings/${ratingId}`);
  return response.data;
}

/**
 * Удаление оценки (только автор или админ)
 */
export async function deleteMessageRating(ratingId: number): Promise<void> {
  await axiosInstance.delete(`/message-ratings/${ratingId}`);
}
